import React from 'react';
import styled from 'styled-components';
import { ReactComponent as LogoSvg } from 'components/Logo.svg';

const Logo = styled(LogoSvg)`
  width: 125px;
  height: auto;
`;

export default () => (
  <Logo className="Logo" />
);
